/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationSettingsSection_company = {
    readonly timeRegistrationSettings: {
        readonly id: string;
        readonly allowDoneTasks: boolean | null;
        readonly allowProjects: boolean | null;
        readonly allowInternalTime: boolean | null;
        readonly allowBillableSplit: boolean | null;
        readonly allowRoles: boolean | null;
        readonly allowExceedingEstimate: boolean | null;
        readonly allowOutsideProjectDates: boolean | null;
        readonly allowOutsideTaskDates: boolean | null;
        readonly requireTaskAssignment: boolean | null;
        readonly requireNote: boolean | null;
        readonly strictMode: boolean | null;
    } | null;
    readonly " $refType": "TimeRegistrationSettingsSection_company";
};
export type TimeRegistrationSettingsSection_company$data = TimeRegistrationSettingsSection_company;
export type TimeRegistrationSettingsSection_company$key = {
    readonly " $data"?: TimeRegistrationSettingsSection_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationSettingsSection_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeRegistrationSettingsSection_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeRegistrationSettingsType",
      "kind": "LinkedField",
      "name": "timeRegistrationSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowDoneTasks",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowProjects",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowInternalTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBillableSplit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRoles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowExceedingEstimate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowOutsideProjectDates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowOutsideTaskDates",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requireTaskAssignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requireNote",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "strictMode",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = '90fec12990ba7b958ea7777ea65df51d';
export default node;
